<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
    class="session-expired-dialog"
  >
    <v-card>
      <v-card-title class="headline error white--text">
        <v-icon left dark>mdi-alert-circle</v-icon>
        Session expirée
      </v-card-title>

      <v-card-text class="pt-4">
        <p class="body-1">
          Votre session a expiré. Vous avez été déconnecté du serveur.
        </p>
        <p class="body-2 grey--text">
          Veuillez vous reconnecter pour continuer à utiliser l'application.
        </p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="handleReconnect">
          <v-icon left>mdi-login</v-icon>
          Se reconnecter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SessionExpiredDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    handleReconnect() {
      // Nettoyer le localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      localStorage.removeItem("email");
      localStorage.removeItem("droits");
      localStorage.removeItem("partnerCode");
      localStorage.removeItem("partnerApps");
      localStorage.removeItem("partnerLicenceLabel");
      this.$store.commit("authentification/clearPartnerFeatures");

      // Fermer le dialog
      this.dialog = false;

      // Rediriger vers login
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.session-expired-dialog .v-card__title.error {
  background-color: #f44336;
}
</style>
